module.exports = __webpack_public_path__ + "static/bernard_1_square-2ebf509c5b5667d967e38c8c45d5af18.jpg";